import styled from "styled-components";

export const Description = styled.h2`
  font-family: ${(props) => props.theme["@font-family"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  color: ${(props) => props.theme["@neutral-600"]};
`;

export const Title = styled.h2`
  font-family: ${(props) => props.theme["@font-family"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  color: ${(props) => props.theme["@neutral-600"]};
  margin-bottom: 42px;
`;

export const SubTitle = styled.h2`
  font-family: ${(props) => props.theme["@font-family"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  color: ${(props) => props.theme["@neutral-600"]};
`;

export const Details = styled.h2`
  font-family: ${(props) => props.theme["@font-family"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  color: ${(props) => props.theme["@color-neutral-400"]};
  margin-bottom: 32px;
`;

export const SubTitleNoEvent = styled.h2`
  font-family: ${(props) => props.theme["@font-family"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  color: ${(props) => props.theme["@color-neutral-400"]};
`;

export const TagIcon = styled.span`
  .vehicleStatusIcon {
    display: inline-flex;
    height: 32px;
    border-radius: 300px;
    font-weight: 600;
    font-size: 14px;
    align-content: center;
    align-items: center;
    padding: 0 12px;
  }
`;

export const WithoutEventsContainer = styled.div`
  height: 75vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  margin-top: 10px;
`;
